import { createFileRoute, redirect } from "@tanstack/react-router";

import { ButtonLink } from "@/components/ui/button";
import { H2 } from "@/components/ui/typography";
import { handlePatreonCallback } from "@/lib/api";

export const Route = createFileRoute("/app/patreon/callback")({
  component: SuccessRoute,
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    code?: string;
  } => {
    // validate and parse the search params into a typed state
    return {
      code: search?.code as string | undefined,
    };
  },
  beforeLoad: async ({ search }) => {
    if (!search.code) {
      throw redirect({ to: "/app" });
    }

    await handlePatreonCallback(search.code);
    throw redirect({ to: "/app" });
  },
  head: () => ({ meta: [{ title: "Feed Operator Patreon" }] }),
});

function SuccessRoute() {
  return (
    <div className="flex items-center justify-center">
      <div className="flex flex-col gap-2">
        <H2>Patreon linked</H2>
        <p>You can now connect your Patreon account to your feed.</p>
        <ButtonLink to="/app">Go to dashboard</ButtonLink>
      </div>
    </div>
  );
}
